import React from 'react';

function LikeSvg() {
  return (
    <svg
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7338 29.5208L29.5208 3C31.8654 3 34.114 3.93138 35.7718 5.58926C37.4297 7.24713 38.3611 9.49569 38.3611 11.8403V23.6273H55.0397C55.894 23.6176 56.7402 23.7938 57.5197 24.1436C58.2991 24.4935 58.9932 25.0086 59.5538 25.6532C60.1144 26.2979 60.5281 27.0568 60.7663 27.8773C61.0045 28.6977 61.0615 29.5602 60.9333 30.4049L56.8667 56.9257C56.6536 58.331 55.9398 59.612 54.8568 60.5325C53.7738 61.4531 52.3945 61.9512 50.9732 61.9352H17.7338M17.7338 29.5208V61.9352M17.7338 29.5208H8.89352C7.33046 29.5208 5.83142 30.1417 4.72617 31.247C3.62092 32.3522 3 33.8513 3 35.4143V56.0416C3 57.6047 3.62092 59.1037 4.72617 60.209C5.83142 61.3142 7.33046 61.9352 8.89352 61.9352H17.7338"
        stroke="black"
        strokeWidth="5.89352"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LikeSvg;
